import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledPatientAbsenceProjectInfo = styled(Flexbox)(
    ({theme: {typography}}) => css`
        ${typography.textSm};

        & > span > b {
            font-weight: 500;
        }
    `
)

export const StyledExpirationDateInfo = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[500]};
    `
)
